import { Component, Input, inject } from '@angular/core';
import { Playlist } from '../../models/playlist';
import {Uploader} from '../../models/uploader'
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import { PlaylistService } from '../../services/playlist.service';


@Component({
  selector: 'app-playlist',
  standalone: true,
  imports: [RouterLink, MatCardModule, MatButtonModule],
  templateUrl: './playlist.component.html',
  styleUrl: './playlist.component.css',
})
export class PlaylistComponent {
  @Input() playlist!: Playlist;
  
  private playlistService = inject(PlaylistService);

  public updatePlaylist(playlistId : string){
    this.playlistService.updatePlaylist(playlistId).subscribe({
        next: (playlists: Playlist[]) => {
          //this.playlists.set(playlists);
          console.log('Playlists fetched successfully:', playlists);
        },
        error: (error: any) => {
          console.error('Failed to fetch playlists:', error);
        }
      });
  }

}
